// Share Zuzu: the share sheet where there is one, otherwise copy the link.
// Returns true when the link was copied, so the button can say so.
export const shareZuzu = async (text: string, url = 'https://www.zuzu.club'): Promise<boolean> => {
  try {
    if (navigator.share) { await navigator.share({ title: 'Zuzu Club', text, url }); return false; }
  } catch { return false; } // the person closed the share sheet
  try { await navigator.clipboard.writeText(url); return true; } catch { return false; }
};

